import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { KeyTakeawaysNodeView } from './KeyTakeawaysNodeView';

/**
 * Custom TipTap node that preserves the key-takeaways-box div
 * with all its inline styles and children, and adds a remove button.
 */
export const KeyTakeawaysNode = Node.create({
  name: 'keyTakeawaysBox',
  group: 'block',
  content: 'block+',
  defining: true,

  parseHTML() {
    return [
      {
        tag: 'div.key-takeaways-box',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      mergeAttributes(HTMLAttributes, {
        class: 'key-takeaways-box',
      }),
      0,
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(KeyTakeawaysNodeView);
  },
});
